/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AIConceptContextRead } from '../models/AIConceptContextRead';
import type { AIConceptContextUpsert } from '../models/AIConceptContextUpsert';
import type { AIConceptInfo } from '../models/AIConceptInfo';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AiConceptsService {

    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List Concept Contexts
     * List all AI concept contexts for a cluster.
     * @param clusterId
     * @returns AIConceptContextRead Successful Response
     * @throws ApiError
     */
    public listConceptContexts(
        clusterId: string,
    ): CancelablePromise<Array<AIConceptContextRead>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/ai-concepts/list-concept-contexts',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Upsert Concept Context
     * Create or update context for an AI concept.
     * @param clusterId
     * @param requestBody
     * @returns AIConceptContextRead Successful Response
     * @throws ApiError
     */
    public upsertConceptContext(
        clusterId: string,
        requestBody: AIConceptContextUpsert,
    ): CancelablePromise<AIConceptContextRead> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/clusters/{cluster_id}/ai-concepts/upsert-concept-context',
            path: {
                'cluster_id': clusterId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * Delete Concept Context
     * Delete an AI concept context.
     * @param contextId
     * @param clusterId
     * @returns any Successful Response
     * @throws ApiError
     */
    public deleteConceptContext(
        contextId: string,
        clusterId: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/clusters/{cluster_id}/ai-concepts/delete-concept-context/{context_id}',
            path: {
                'context_id': contextId,
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

    /**
     * List Available Ai Concepts
     * Get list of all available AI concepts with their names and descriptions.
     * @param clusterId
     * @returns AIConceptInfo Successful Response
     * @throws ApiError
     */
    public listAvailableAiConcepts(
        clusterId: string,
    ): CancelablePromise<Array<AIConceptInfo>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/clusters/{cluster_id}/ai-concepts/list-available-ai-concepts',
            path: {
                'cluster_id': clusterId,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }

}
